<template>
  <div style="margin-top: -2.25rem" class="text-center text-sm-right mb-8">
    <div class="segmented">
      <div class="track">
        <v-chip color="white" class="chip" :class="chipClass" />
        <button
          v-for="opt in options"
          :key="opt"
          @click="switchOption(opt)"
          v-ripple
          class="segment"
          :class="{ 'is-active': value === opt }">
          <span class="label" :class="{ active: value === opt }">
            {{ opt }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CatalogSwitch',
  props: {
    route: { type: Object, required: true },
    initialValue: { type: String, required: true },
    options: {
      type: Array,
      required: true,
      validator: (arr) => arr.length === 2,
    },
  },
  data() {
    return {
      value: this.initialValue,
    }
  },
  computed: {
    isFirstOptionSelected() {
      return this.options[0] === this.value
    },
    chipClass() {
      return this.isFirstOptionSelected ? 'left' : 'right'
    },
  },
  methods: {
    switchOption(value) {
      this.value = value
      const arena = this.$store.getters.arena
      const route = arena
        ? { ...this.route, params: { arena: arena.id } }
        : this.route
      return setTimeout(() => this.$router.push(route), 80)
    },
  },
}
</script>

<style scoped>
.segmented {
  display: inline-block;
}

.track {
  --track-width: 320px;
  --track-height: 48px;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  width: var(--track-width);
  height: var(--track-height);
  background: var(--v-primary-base);
  border-radius: 9999px;
  padding: 0; /* inner spacing handled by chip positioning */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) inset;
  overflow: hidden;
}

.chip.v-chip {
  --track-control-padding: 6px;
  --chip-width: calc(50% - calc(var(--track-control-padding) * 2));
  --chip-height: calc(var(--track-height) - 2 * var(--track-control-padding));
  --chip-border-radius: calc(var(--chip-height) / 2);
  position: absolute;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  transition: left 80ms ease, width 80ms ease;
  border-radius: var(--chip-border-radius);
  width: var(--chip-width);
  height: var(--chip-height);
  top: var(--track-control-padding);
  left: var(--track-control-padding);
}

.chip.right {
  left: calc(50% + var(--track-control-padding));
}

.segment {
  position: relative;
  border: none;
  background: transparent;
  padding: 0; /* full-area clickable */
  cursor: pointer;
  outline: none;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}

.segment:focus-visible {
  /* subtle focus ring */
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.55);
  border-radius: 9999px;
}

.label {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  font-size: 0.875rem;
  transition: color 80ms ease;
  white-space: nowrap;
}

.label.active {
  color: var(--v-primary-base);
}
</style>
